import { AuthFlow } from '@pkg/hooks/authentication/types';

export enum LocalStorageKeys {
    /**
     * This is used to inform us the auth flow a user is currently
     * going through (e.g. due to checkout or home page)
     */
    AuthFlow = 'authFlow',

    /**
     * This is used to inform us where was the entry point for the user
     * after a successful login (e.g. post auth redirect). This can be
     * used to idenfity how to deal with navigation if a user decides
     * to go back to the previous page.
     */
    AuthEntryPoint = 'authEntryPoint',

    DraftUserId = 'draftUserId',
    EmojiIds = 'emojiIds',
    FirstTimeUserExperience = 'ftue',
    OAuthLoggedIn = 'OAuthLoggedIn',
    RemoveDraftUser = 'removeDraftUser',
}

export enum LocalStorage2FAKeys {
    TimeSinceRequire = 'time_since_require_prompt',
    TimeSincePostPurchase = 'time_since_post_purchase_prompt',
}

export const LocalStorageAuthFlowValues = {
    ...AuthFlow,
};
